import { connect } from 'react-redux';
import ScheduleInfo from 'components/ScheduleModal/ScheduleInfo';
import { injectIntl } from 'react-intl';
import { contactSelectors, currentUserSelectors } from '@lifesize/nucleus';
import {
  setPillNotificationWithTimeout
} from 'actions/Notification';
import { getInviteForExtension, getInviteMailLinkForExtension } from 'actions/Invite';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const getContactsByIds = contactSelectors.getContactsByIdsGenerator(state);
  const contactId = _get(state, 'app.scheduleModal.contactId');
  const myInfo = currentUserSelectors.myInfo(state);
  const scheduleOneTime = _get(state, 'app.scheduleModal.scheduleOneTime');

  let contact;
  let editingSchedule = false;

  if (contactId === myInfo.id) {
    contact = myInfo;
  } else {
    contact = getContactsByIds(contactId)[0] || {};
  }

  if (ownProps.contact) {
    editingSchedule = true;
  }

  return ({
    myInfo,
    contact,
    editingSchedule,
    scheduleOneTime
  });
};

const mapDispatchToProps = dispatch => ({
  notifyWithTimeout: message => dispatch(setPillNotificationWithTimeout(message)),
  getInviteForExtension: async extension => dispatch(getInviteForExtension(extension)),
  getInviteMailLinkForExtension: async extension => dispatch(getInviteMailLinkForExtension(extension))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    getInviteForExtension: async () => dispatchProps.getInviteForExtension(_get(stateProps, 'contact.dialString')),
    getInviteMailLinkForExtension: async () => dispatchProps.getInviteMailLinkForExtension(_get(stateProps, 'contact.dialString')),
  }
);

export default injectIntl(connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ScheduleInfo));
